__turbopack_context__.v({
  "menuBox": "toMVPG_menuBox",
  "styleGuideHeader": "toMVPG_styleGuideHeader",
});
